import { Link } from "@tanstack/react-router";
import logoAsset from "@/assets/flashweb-logo.webp.asset.json";
import { CATEGORIES } from "@/data/blog";
import type { ReactNode } from "react";

export function BlogHeader() {
  return (
    <header className="sticky top-0 z-40 border-b border-border/50 bg-background/80 backdrop-blur-xl">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-6">
        <Link to="/" className="flex items-center gap-2">
          <img src={logoAsset.url} alt="FlashWeb" width="144" height="36" className="h-9 w-auto brightness-110 contrast-125" />
          <span className="font-display text-lg font-bold tracking-tight">
            FlashWeb <span className="text-muted-foreground font-normal">Blog</span>
          </span>
        </Link>
        <nav className="hidden items-center gap-6 text-sm text-muted-foreground md:flex">
          <Link to="/blog" className="hover:text-foreground">Tutti gli articoli</Link>
          {CATEGORIES.slice(0, 4).map((c) => (
            <Link
              key={c.slug}
              to="/blog/categoria/$slug"
              params={{ slug: c.slug }}
              className="hover:text-foreground"
            >
              {c.name}
            </Link>
          ))}
        </nav>
        <Link
          to="/"
          className="rounded-full bg-primary px-4 py-2 text-sm font-semibold text-primary-foreground hover:opacity-90"
        >
          Richiedi preventivo
        </Link>
      </div>
    </header>
  );
}

export function BlogFooter() {
  return (
    <footer className="border-t border-border/40 bg-card/30 mt-24">
      <div className="mx-auto max-w-7xl px-6 py-12">
        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2">
              <img src={logoAsset.url} alt="FlashWeb" width="120" height="30" className="h-8 w-auto" />
              <span className="font-display text-base font-bold">FlashWeb</span>
            </div>
            <p className="mt-3 text-sm text-muted-foreground">
              Siti web professionali consegnati in 48 ore. Made in Ticino.
            </p>
          </div>
          <div>
            <h4 className="text-sm font-semibold">Categorie</h4>
            <ul className="mt-3 space-y-2 text-sm text-muted-foreground">
              {CATEGORIES.map((c) => (
                <li key={c.slug}>
                  <Link to="/blog/categoria/$slug" params={{ slug: c.slug }} className="hover:text-foreground">
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="text-sm font-semibold">FlashWeb</h4>
            <ul className="mt-3 space-y-2 text-sm text-muted-foreground">
              <li><Link to="/" className="hover:text-foreground">Home</Link></li>
              <li><a href="/#showcase" className="hover:text-foreground">Esempi</a></li>
              <li><a href="/#price" className="hover:text-foreground">Prezzi</a></li>
              <li><Link to="/blog" className="hover:text-foreground">Blog</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-sm font-semibold">Contatti</h4>
            <ul className="mt-3 space-y-2 text-sm text-muted-foreground">
              <li>Zug · Bedano — Svizzera</li>
              <li><a href="mailto:info@flash-web.ch" className="hover:text-foreground">info@flash-web.ch</a></li>
            </ul>
            <h4 className="mt-6 text-sm font-semibold">Legale</h4>
            <ul className="mt-3 space-y-2 text-sm text-muted-foreground">
              <li><Link to="/privacy-policy" className="hover:text-foreground">Privacy Policy</Link></li>
              <li><Link to="/cookie-policy" className="hover:text-foreground">Cookie Policy</Link></li>
              <li><Link to="/termini-condizioni" className="hover:text-foreground">Termini</Link></li>
              <li><Link to="/impressum" className="hover:text-foreground">Impressum</Link></li>
            </ul>
          </div>
        </div>
        <div className="mt-10 border-t border-border/40 pt-6 text-xs text-muted-foreground">
          © {new Date().getFullYear()} FlashWeb Agency · Tutti i diritti riservati
        </div>
      </div>
    </footer>
  );
}

export function BlogShell({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <BlogHeader />
      <main>{children}</main>
      <BlogFooter />
    </div>
  );
}
